import useOnce from '../useOnce';

function useUnmount(handle) {
    useOnce(() => () => {
        handle();
    });
}

export default useUnmount;
